<script setup>
import { onMounted, ref, computed } from "vue";

onMounted(() => {
  setTimeout(() => {
    $(".owl-carousel").owlCarousel({
      autoplay: true,
      slideTransition: "linear",
      autoplayTimeout: 4000,
      autoplaySpeed: 4000,
      autoWidth: true,
      // width: 200,
      margin: 100,
      // autoplayHoverPause:true,
      // stopOnHover:true,
      loop: true,
      fluidSpeed: true,
      // smartSpeed: 4000,
      responsive: {
        0: {
          items: 2.2,
          margin: 40,
        },
        640: {
          items: 3.2,
          margin: 80,
        },
        840: {
          items: 3.2,
        },
        1200: {
          items: 3,
        },
        1600: {
          items: 3,
        },
        1920: {
          items: 3,
        },
      },
    });
  }, 1000);
});
</script>

<template>
  <div class="benefits-bar">
    <div class="title">
      <h3>Plans include <span>Benefits</span> for:</h3>
    </div>
    <div class="owl-carousel benefits">
      <div class="benefit">
        <img src="/images/apple-tv+-white.webp" alt="Apple TV+" width="79" height="30" />
      </div>
      <div class="benefit">
        <img src="/images/disney-white.webp" alt="Disney+" width="55" height="30" />
      </div>
      <div class="benefit">
        <img src="/images/prime-white.webp" alt="Prime" width="48" height="30" />
      </div>
      <div class="benefit">
        <img src="/images/vue-white.webp" alt="Vue" width="71" height="30" />
      </div>
      <div class="benefit">
        <img src="/images/greggs2-white.webp" alt="Greggs" width="120" height="18" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.benefits-bar {
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
  padding: 4rem 2rem 6rem;
  filter: drop-shadow(var(--box-shadow));

    @media (max-width: 992px) {
      padding: 0rem 2rem 0rem;
    }

  .title {
    color: var(--primary);
    margin: 0;
    h3 {
      color: var(--primary);
      width: 120px;
      margin-right: 1em;

      @media (min-width: 640px) {
        width: 200px;
      }

      span {
        color: var(--banana);
      }
    }
  }
}

.benefits {
  display: none;
  justify-content: center;
  align-items: center;

  &.owl-loaded {
    display: flex !important;
  }

  .benefit {
    display: flex;
    height: 60px;
    justify-content: center;
    align-items: center;

    img {
      max-height: 100%;
      max-width: 120px;
      width: auto;
    }

    @media (max-width: 840px) {
      height: 45px;

      // img {
      //     max-width: 150px;
      // }
    }

    @media (max-width: 640px) {
      height: 30px;

      // img {
      //     max-width: 120px;
      // }
    }
  }
}
</style>
